import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import SpriteComponent from '../../../Component/Render/Sprite';
import Renderable from '../../../Component/Renderable';

interface IAlphaPulseLoopData {
    duration: number;
    alpha: number[];
    childrenName?: string;
    delay: number;
    fadeToStartAlphaDuration?: number;
    repetitions?: number
}

export class AlphaPulseLoop extends AnimationClip<IAlphaPulseLoopData> {
    public *execute(
        gameObject: GameObject,
        meta: IAlphaPulseLoopData
    ): IterableIterator<number> {
        let renderable: any;
        let childrenObject;
        if (meta.childrenName) {
            childrenObject = gameObject.findChildByName(meta.childrenName);
            renderable =
                childrenObject.getComponent(SpriteComponent) ??
                childrenObject.getComponent(Renderable);
            renderable.visible = true;
        } else {
            renderable =
                gameObject.getComponent(SpriteComponent) ??
                gameObject.getComponent(Renderable);
            renderable.visible = true;
        }
        const tween = this.getTween(renderable);

        if (meta.fadeToStartAlphaDuration) {
            tween.to({alpha: meta.alpha[0] }, meta.fadeToStartAlphaDuration);
            yield* this.startTween(tween);
        } else {
            renderable.alpha = meta.alpha[0];
        }

        tween
            .to({ alpha: meta.alpha[1] }, meta.duration)
            .yoyo(true)
            .repeat(meta.repetitions || Infinity)
            .delay(meta.delay ?? 0)
            .easing(Easing.Linear.None)
            .start(this.elapsedTime);

        // Loop.
        while (true) yield;
    }
}
